import Swiper, { Scrollbar, Pagination, FreeMode, Mousewheel } from 'swiper'
import 'swiper/css'
import 'swiper/css/scrollbar'
import 'swiper/css/pagination'
import { countUp } from '@/scripts/stats'

const init = (wrapper) => {
  const carousel = wrapper.querySelector('.js-content-carousel-2-carousel')
  const navType = wrapper.dataset.navType || 'progressbar'

  const swiper = new Swiper(carousel, {
    modules: [
      ...[navType === 'progressbar' ? Pagination : Scrollbar],
      Pagination,
      FreeMode,
      Mousewheel
    ],
    cssMode: false,
    slidesPerView: 'auto',
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar'
    },
    on: {
      init: () => {
        wrapper.querySelectorAll('.js-content-carousel-2-slide-number').forEach((item) => {
          countUp(item.parentNode, item)
        })
      }
    }
  })
}

export default () => {
  document.querySelectorAll('.js-content-carousel-2').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}
